import { observer }          from 'mobx-react-lite';
import ButtonActions         from '@widesk-ui/components/ButtonActions';
import { Modal }             from '@widesk-ui/components/modal/Modal';
import currentEditorStore    from '@/TokamapEditor/stores/currentEditorStore';
import { ShareAltOutlined }  from '@ant-design/icons';
import ShareForm             from '@forms/ShareForm';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';

const ShareButton = observer(() => {
	if (!currentEditorStore.isCenterDefined) return null;

	return (
		<ButtonActions
			type="default"
			forceButton
			actions={[{
				icon: <ShareAltOutlined />,
				label: 'Partager',
				onClick: () => {
					Modal.open({
						okText: 'Copier le code',
						title: 'Partager le projet',
						children: <ShareForm project={currentProjectEditorStore.get.project} />,
					});
				},
			}]}
		/>
	);
});

export default ShareButton;